import { Environments } from '@/config';
import { MHHS_PRODUCTION } from './mhhs.production';
import { MHHS_STAGING } from './mhhs.staging';

export const MHHS = import.meta.env.MODE === Environments.PROD ? MHHS_PRODUCTION : MHHS_STAGING;
